import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { Link } from "react-router-dom"
import { getProjectUUIDAction } from "../../../store/projects/actions"
import { getMasterTemp } from "../../../store/templates/actions"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import email2 from "../../../assets/img/project-1.jpg"
import { map } from "lodash"
import axios from "axios"
import { API_URL } from "../../../helpers/app_url";
import Moment from 'react-moment';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import et1 from "../../../assets/img/email-1.png"
import et2 from "../../../assets/img/email-2.png"
import et3 from "../../../assets/img/email-3.png"
import et4 from "../../../assets/img/email-4.png"
import et5 from "../../../assets/img/email-5.png"
import et6 from "../../../assets/img/email-6.png"
import createNew from "../../../assets/img/new-email.png"
import Swal from 'sweetalert2';
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  CardHeader,
  CardFooter,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from "reactstrap"
import defalutImg from "../../../assets/img/250.png"
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import ActionResend from "components/buttons/actionResend";
import ActionAnalytics from "components/buttons/actionAnalytics";
class projectMail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      masterTemplates: [],
      campaigns: [],
      used: [],
      customTemplates: [],
      gridLoader: true,
      reports: [
        { title: "Email Sent", iconClass: "bx-copy-alt", description: "14" },
        {
          title: "# Prospects",
          iconClass: "bx-archive-in",
          description: "6",
        },
        {
          title: "# SRR",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "# Clients",
          iconClass: "bx-purchase-tag-alt",
          description: "2",
        },
      ]
    }
    this.toggleReportCanvas = this.toggleReportCanvas.bind(this);
  }

  reporttoggle() {
    this.setState(prevState => ({
      isReportRight: !prevState.isReportRight
    }));
  }
  toggleReportCanvas() {
    this.setState({ report: "", isReportRight: !this.state.isReportRight });
    this.reporttoggle();
  }
   toggleReportCanvas = arg => {
    const report = arg;
    this.setState({
      report: {
        id:report.id,
        createdDate: report.createdDate,
        emailCampaignTitle: report.emailCampaignTitle,
        emailTargetTypeId: report.emailTargetTypeId,
        emailTargetSubTypeId: report.emailTargetSubTypeId,
        emailCampaignTemplateTitle	: report.emailCampaignTemplateTitle,
        emailCampaignTargetTypeTitle: report.emailCampaignTargetTypeTitle,
        emailCampaignTargetTypeSubTitle	: report.emailCampaignTargetTypeSubTitle,
        emailCampaignPublishStatus: report.emailCampaignPublishStatus
           
      },
     
    });
    this.fetchReport(report.id);
    this.reporttoggle();
  };

 fetchReport(id) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      Id: id,
    };
    axios
      .get(`${API_URL}ProjectEmailCampaign/projectemailcampaignstats`, { headers, params })
      .then((response) => {
        this.setState({ reportsData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  handleResend = (rowData) => {
    const id = rowData.id;
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;

    fetch(`${API_URL}ProjectEmailCampaign/resendprojectemailcampaign?Id=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to resend email campaign');
        }
        return response.json();
      })
      .then((data) => {
        if (data.success === true) {
          this.props.history.push(`/pre-construction/mail-send/${data.projectEmailCampaign.id}/${data.projectEmailCampaign.projectEmailCampaignId}`);
        } else {
        }
      })
      .catch((error) => {
        console.error('Resend error:', error);
      });
  };



  componentDidMount() {

    const { match: { params }, ongetProjectUUIDAction, onGetMasterTemp } = this.props;

    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetMasterTemp(localStorage.getItem('userId'));
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = 'Bearer ' + token;
       this.setState({ gridLoader: true });
      axios.get(API_URL + 'ProjectEmailCampaign/allagentProjectEmailCampaigns', {
        params: {
          agentId: localStorage.getItem('userId'),
          projectId: this.props.match.params.projectId,
        },
        headers: { Authorization: str }
      })
        
        .then(res => {
          const campaigns = res.data;
          this.setState({ campaigns, gridLoader: false });
        })
        .catch(error => {
          // Handle error here
          console.error('Error fetching data:', error);
        }),
        axios.get('https://rscoreapi.azurewebsites.net/api/ProjectMasterEmailTemplate/alltemplates', {
          headers: { Authorization: str }
        })
          .then(res => {
            const masterTemplates = res.data;
            this.setState({ masterTemplates });
          }),
        axios.get('https://rscoreapi.azurewebsites.net/api/ProjectEmailTemplate/alltemplates', {
          params: {
            agentId: parseInt(localStorage.getItem("userId")),
          }, headers: { Authorization: str }
        })
          .then(res => {
            const customTemplates = res.data;
            this.setState({ customTemplates });
          })
      axios.get(API_URL + 'ProjectEmailCampaign/allProjectEmailCampaignByProjectIdUniqueCurrentlyUsed', {
        params: {
          agentId: localStorage.getItem('userId'),
          projectId: params.id,
        }, headers: { Authorization: str }
      })
        .then(res => {
          const used = res.data;
          this.setState({ used });
        })
    }


  }

deleteList = (rowData) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'This action will delete the campaign. You won’t be able to revert this!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
      const id = rowData.id;
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      fetch(`${API_URL}ProjectEmailCampaign/DeleteDraftProjectEmailCampaign?id=${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Failed to delete campaign');
          return response.json();
        })
        .then((data) => {
          if (data.success) {
             const campaigns = this.state.campaigns.filter(c => c.id !== id);
            this.setState({ campaigns });
            Swal.fire('Deleted!', 'The campaign has been deleted.', 'success');
           
          } else {
            Swal.fire('Failed!', data.message || 'Delete failed.', 'error');
          }
        })
        .catch((error) => {
          console.error('Delete error:', error);
          Swal.fire('Error!', 'Something went wrong.', 'error');
        });
    }
  });
};
  render() {
    const { projectData, templates, isResponsive } = this.props;
    const { reportsData, report } = this.state;
    
    return (
      <React.Fragment>
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
              <Col sm='2' className="pe-0" >
                <ProjectSidebar isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Email Campaigns")} />
                  </Col>
                  <Col sm="4">
                    <h2 className="">{this.props.t(projectData.projectName)}</h2>
                  </Col>
                </Row>
                <Row>

                  <Col lg="12">

                    <Card>
                      <CardBody>

                        {/* <h4 className="card-title mb-4">All Mail Campaign</h4> */}



                        <DataTable loading={this.state.gridLoader}  className="" stripedRows value={this.state.campaigns} paginator rows={5} 
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " 
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" emptyMessage="No data available" 
                        >
                            <Column
                              header="#"
                              body={(rowData, options) => options.rowIndex + 1}
                              style={{ width: '60px'}}
                            />
                          <Column field="date" header="Date" body={(rowData) => (
                            <Moment format="D MMM YY">{rowData.createdDate}</Moment>
                          )}></Column>
                          <Column field="title" header="Title" body={(rowData) => (
                            rowData.emailCampaignTitle || 'N/A'
                          )}></Column>
                          <Column field="target" header="Target" body={(rowData) => (

                            rowData.emailCampaignTargetTypeTitle ? rowData.emailCampaignTargetTypeTitle + "-" + rowData.emailCampaignTargetTypeSubTitle : 'N/A'
                          )}></Column>
                          <Column field="template" header="Email Template" body={(rowData) => (
                            rowData.emailCampaignTemplateTitle || 'N/A'
                          )}></Column>
                            { !isResponsive && (
                              
                                <Column
                                  field="status"
                                  header="Status"
                                  body={(rowData) => rowData.emailCampaignPublishStatus}
                                />
                               )}
                                { !isResponsive && (
                                <Column
                                  field="action"
                                  header="Action"
                                  body={(rowData) => {
                                    const status = rowData.emailCampaignPublishStatus;

                                    if (status === "Draft") {
                                      return (
                                        <>
                                          <ActionEdit to={`/pre-construction/mail-editors/${this.props.match.params.projectId}/${rowData.id}`} />
                                          <ActionDelete onClick={() => this.deleteList(rowData)} />
                                        </>
                                      );
                                    } else if (status === "Published") {
                                      return (
                                        <>
                                          <ActionResend onClick={() => this.handleResend(rowData)} />
                                          <ActionAnalytics onClick={() => this.toggleReportCanvas(rowData)} />
                                        </>
                                      );
                                    }

                                    return null;
                                  }}
                                />
                               )}
                           
                        </DataTable>






                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                {!isResponsive && (
                <Row>

                  <Col lg="12">




                    <Row>

                      <Col lg="12">

                        <Row>

                          <Col lg="6">

                            <Card>
                              <CardBody>


                                <h4 className="card-title mb-4">Available Themes</h4>



                                <Row className="mb20">
                                  {
                                    this.state.masterTemplates.map(masterTemplate => {
                                      const imageMap = {
                                        34: et5,
                                        36: et6,
                                        38: et3,
                                        37: et1,
                                        40: et2,
                                       
                                      };

                                      return (
                                        <Col sm="4" className="mb20" key={masterTemplate.id}>
                                          <Card>
                                            <CardBody className="p-0">
                                              <Link
                                                
                                                to={`/pre-construction/mail-editor/${this.props.match.params.projectId}/${masterTemplate.id}`}

                                                className="previewClass card-link float-end tempLink"
                                              > <img
                                                  src={imageMap[masterTemplate.id] || et1}
                                                  className="img-fluid"
                                                  alt={masterTemplate.templateTitle}
                                                /></Link>
                                            </CardBody>

                                          </Card>
                                        </Col>
                                      );
                                    })
                                  }
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col lg="6">

                            <Card>
                              <CardBody>


                                <h4 className="card-title mb-4">Custom Themes</h4>
                                <Row className="mb20">
                                  <Col sm="4" className="mb20">
                                    <Card>
                                      <CardBody className="p-0">
                                        <Link
                                          to={`/pre-construction/new-mail-editor/${this.props.match.params.projectId}`}
                                          className="previewClass card-link float-end tempLink"
                                        > <img
                                            src={createNew}
                                            className="img-fluid"

                                          /></Link>
                                      </CardBody>

                                    </Card>
                                  </Col>
                                  {
                                    this.state.customTemplates
                                      .map(customTemplate =>
                                        <Col sm="4" className="mb20" key={customTemplate.id}>

                                          <Card>

                                            <CardBody className="p-0">
                                              <Link to={"/pre-construction/mail-editor-new/" + this.props.match.params.projectId + "/" + customTemplate.id} className="card-link  tempLink">
                                                <div className="image-container">
                                                  <span className="template-title">{customTemplate.templateTitle}</span>
                                                  <img
                                                    src={defalutImg}
                                                    className="img-fluid"
                                                    alt={customTemplate.templateTitle}
                                                  />
                                                </div>

                                              </Link>

                                            </CardBody>

                                          </Card>
                                        </Col>
                                      )}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>


                        </Row>

                      </Col>
                    </Row>
                  </Col>
                </Row>
                )}
              </Col>
            </Row>

          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isReportRight}
          direction="end"
          toggle={this.toggleReportCanvas}
        >
          <OffcanvasHeader toggle={this.toggleReportCanvas}>
            Campaign Report
          </OffcanvasHeader>
          <OffcanvasBody>
                 <Table className="table table-nowrap table-centered">
                 
                  <Tbody>
                    <Tr>
                      <Th scope="row">Date</Th>
                      <Td>{report?.createdDate ? <Moment format="DD MMM YYYY">{report?.createdDate}</Moment> : ''}</Td>
                    </Tr>
                    <Tr>
                      <Th scope="row">Title</Th>
                      <Td>{report?.emailCampaignTitle	}</Td>
                    </Tr>
                    <Tr>
                      <Th scope="row">Target</Th>
                      <Td>{report?.emailCampaignTargetTypeTitle	 + "-" +	report?.emailCampaignTargetTypeSubTitle	}</Td>
                    </Tr>
                     <Tr>
                      <Th scope="row">Email Template</Th>
                      <Td>{report?.emailCampaignTemplateTitle	}</Td>
                    </Tr>
                     <Tr>
                      <Th scope="row">Status</Th>
                      <Td>{report?.emailCampaignPublishStatus		}</Td>
                    </Tr>
                    {reportsData && reportsData.map((report, index) => (
                      <Tr key={index}>
                        <Th scope="row">{report.status}</Th>
                        <Td>{report.count}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>                     
          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}

projectMail.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
  className: PropTypes.any,
  onGetMasterTemp: PropTypes.func,
  templates: PropTypes.array,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({ Project, Template }) => (
  {
    projectData: Project.projectData,
    templates: Template.templates,
    loading: Project.loading

  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  onGetMasterTemp: (agentId) => dispatch(getMasterTemp(agentId))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectMail)))
